// context/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const [colorTheme, setColorTheme] = useState(localStorage.getItem('colorTheme') || 'default');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('colorTheme', colorTheme);
    // Apply color theme classes
    document.documentElement.className = `${colorTheme} ${theme}`;
  }, [colorTheme, theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const changeColorTheme = (newColorTheme) => {
    setColorTheme(newColorTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, colorTheme, toggleTheme, changeColorTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};